import React from "react";

import "./styles.css";

import { VideoStreamProvider, useVSU } from "./store";
import FiltersToolbar from "./components/FiltersToolbar";
import Legend from "./components/Legend";
import Section from "./components/Section";
import VideoSection from "./components/VideoSection";
import StatisticsPanel from "./components/StatisticsPanel";
import PieCharts from "./components/PieCharts";
import SummaryTable from "./components/SummaryTable";

// Точка входа модуля.
// Крошки и заголовок раздела рисует внешний MainLayout (роут), поэтому внутри их нет.
// lang / onLangChange (необязательные) позволяют управлять языком из глобальной шапки:
//   <MainLayout title={...} component={() => <VideoStreamUpgrade lang={appLang} onLangChange={setAppLang} />} />
// Если пропы не переданы — модуль показывает собственный переключатель РУС/ҚАЗ (автономный режим).
export default function VideoStreamUpgrade({ lang, onLangChange }) {
  return (
    <VideoStreamProvider lang={lang} onLangChange={onLangChange}>
      <Screen />
    </VideoStreamProvider>
  );
}

function Screen() {
  const {
    t,
    lang,
    setLang,
    langControlled,
    filterCaption,
    loading,
    error,
    meta,
    dashboard,
    reload,
  } = useVSU();

  return (
    <div className="video-stream-upgrade vsu" lang={lang}>
      {/* Собственный переключатель языка — только когда язык не управляется извне.
      {!langControlled && (
        <div className="vsu-langbar">
          <div className="vsu-langset">
            <button
              className={"vsu-langbtn" + (lang === "ru" ? " active" : "")}
              onClick={() => setLang("ru")}
            >
              РУС
            </button>
            <button
              className={"vsu-langbtn" + (lang === "kk" ? " active" : "")}
              onClick={() => setLang("kk")}
            >
              ҚАЗ
            </button>
          </div>
        </div>
      )} */}

      <FiltersToolbar />
      <Legend />

      {/* Ошибка запроса: нейтральное сообщение с возможностью повторить.
          Пустые диаграммы как «нулевые данные» не показываем. */}
      {error && !dashboard ? (
        <div className="vsu-section">
          <div className="vsu-section-body">
            <div className="vsu-empty">
              <div className="vsu-empty-ic">⚠</div>
              <b>{t("loadErrT")}</b>
              <div>{t("loadErrD")}</div>
              <button className="vsu-pbtn vsu-retry" onClick={reload}>
                {t("retry")}
              </button>
            </div>
          </div>
        </div>
      ) : !dashboard ? (
        // Ждём только основной ответ /dashboard. Списки фильтров (/meta) подгружаются
        // отдельно и на показ секций не влияют (иначе лоадер висит, пока не придёт meta).
        <div className="vsu-section">
          <div className="vsu-section-body">
            <div className="vsu-empty">
              <b>{t("loading")}</b>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Section title={t("secView")} caption={filterCaption}>
            <VideoSection />
          </Section>

          <Section title={t("secStat")} caption={filterCaption}>
            <StatisticsPanel />
          </Section>

          <Section title={t("secPies")} caption={filterCaption}>
            <PieCharts />
          </Section>

          <Section title={t("secTable")} caption={filterCaption}>
            <SummaryTable />
          </Section>
        </>
      )}
    </div>
  );
}
